/**
 * 自研系统界面截图（挂到产品中心对应条目上，不单独做频道）
 * 截图目录：public/images/systems/（见 README）
 */

const sys = (file) => `/images/systems/${file}`

/** 产品中心列表卡片：每条产品一张封面（勿多张拼在一张图里） */
export const catalogCover = (file) => `/images/systems/catalog/${file}`

const packs = {
  'smart-power-cloud': {
    tagline: '天津高仁智慧用电云平台：电力监测、运行报表、用电分析与四象限电能、自定义报表。',
    galleryCover: sys('power-curve.png'),
    coverFallback: '/images/pdf-pages/gaoren-09.png',
    highlights: [
      { label: '部署方式', value: '私有化 / 本地部署' },
      { label: '适用场景', value: '工厂、园区、配电室、院校实训' },
      { label: '数据维度', value: '回路树、五分钟曲线、四象限电能' },
      { label: '分析能力', value: '同比/环比、自定义报表与饼图' },
    ],
    screenshots: [
      {
        title: '电力数据 · 有功功率曲线',
        desc: '按组织机构与回路（如主进线柜）查看日原始数据；五分钟间隔 A/B/C 相与总有功功率曲线及极值标注。',
        image: sys('power-curve.png'),
        fallback: '/images/pdf-pages/gaoren-09.png',
      },
      {
        title: '电力运行报表',
        desc: '按日/月/自定义查询各回路有功、无功、视在功率与功率因数的最大/最小值、发生时间及平均值。',
        image: sys('power-daily-report.png'),
        fallback: '/images/pdf-pages/gaoren-10.png',
      },
      {
        title: '用电分析 · 同比分析',
        desc: '按年对比本期与同期用电量，柱状图配合同比、累计同比数据表，支持查询与导出。',
        image: sys('power-yoy.png'),
        fallback: '/images/pdf-pages/gaoren-11.png',
      },
      {
        title: '四象限电能 · 日报',
        desc: '正向/反向有功与无功电度分时柱状图，回路明细表，支持日/月/年报与导出。',
        image: sys('power-quadrant.png'),
        fallback: '/images/pdf-pages/gaoren-13.png',
      },
      {
        title: '自定义用电报表 · 饼图',
        desc: '按动力站/回路勾选后查看自定义用电占比饼图，可与报表、导出联动。',
        image: sys('power-custom-pie.png'),
        fallback: '/images/pdf-pages/gaoren-14.png',
      },
      {
        title: '设备日同环比分析',
        desc: '单回路（如消防喷淋机械泵）按小时展示同比、环比柱状图与明细表。',
        image: sys('power-yoy-modal.png'),
        fallback: '/images/pdf-pages/gaoren-14.png',
      },
    ],
  },
  'smart-pv-cloud': {
    tagline: '天津高仁智慧用电/光伏云平台：多站地图看板、逆变器监测、报警闭环与网关、服务器运维。',
    galleryCover: sys('pv-dashboard.png'),
    coverFallback: '/images/pdf-pages/gaoren-15.png',
    highlights: [
      { label: '电站规模', value: '多站地图集中管理' },
      { label: '监测对象', value: '逆变器、网关、表计' },
      { label: '报警分级', value: '普通 / 严重 / 事故' },
      { label: '运维监控', value: '网关在线率、服务 CPU/内存/JVM' },
    ],
    screenshots: [
      {
        title: '光伏发电 · 综合看板',
        desc: '电站数量与装机容量、当前发电功率；全国地图标注电站；日/月/年发电量、收益与社会效益；年发电量柱状趋势。',
        image: sys('pv-dashboard.png'),
        fallback: '/images/pdf-pages/gaoren-15.png',
      },
      {
        title: '事件记录 · 报警信息',
        desc: '未处理报警汇总；报警类型雷达分析与等级占比；电站设备报警列表、筛选与一键确认。',
        image: sys('pv-alarm.png'),
        fallback: '/images/pdf-pages/gaoren-16.png',
      },
      {
        title: '逆变器状态',
        desc: '按电站与逆变器查看设备档案、日/月/年发电量与收益、实时功率表盘及功率与发电量趋势曲线。',
        image: sys('pv-inverter.png'),
        fallback: '/images/pdf-pages/gaoren-17.png',
      },
      {
        title: '逆变器效率 / 逆变器数据',
        desc: '按电站、日期查看各逆变器 5 分钟粒度效率色块表，良好/较差/故障图例，支持查询与导出。',
        image: sys('pv-inverter-data.png'),
        fallback: '/images/pdf-pages/gaoren-18.png',
      },
      {
        title: '系统运行 · 网关通讯状态',
        desc: '在线/离线总数与在线率；各电站网关代码、型号、最后上传与采集时间及服务连接状态。',
        image: sys('pv-gateway.png'),
        fallback: '/images/pdf-pages/gaoren-19.png',
      },
      {
        title: '系统运行 · 服务运行状态',
        desc: '服务器系统与磁盘占用；CPU、内存、JVM 实时占比及监控曲线。',
        image: sys('pv-server.png'),
        fallback: '/images/pdf-pages/gaoren-20.png',
      },
      {
        title: '配电图 / 光伏监测单线图',
        desc: '组串、逆变器与并网柜单线示意及实时数据点位。',
        image: sys('pv-single-line.png'),
        fallback: '/images/pdf-pages/gaoren-21.png',
      },
    ],
  },
}

const platformMeta = {
  'smart-power-cloud': {
    platformName: '智慧用电云平台',
    model: '智慧用能云',
    load: '私有化部署',
  },
  'smart-pv-cloud': {
    platformName: '智慧光伏发电云平台',
    model: '光伏云',
    load: '多站集中运维',
  },
}

function shotFileKey(image) {
  const m = String(image).match(/\/([^/]+)\.(png|jpe?g|webp)$/i)
  return m ? m[1] : 'module'
}

/** 每张界面截图 → 产品中心一条小产品 */
export function screenshotProducts(packId) {
  const pack = packs[packId]
  const meta = platformMeta[packId]
  if (!pack || !meta) return []

  return pack.screenshots.map((shot) => {
    const key = shotFileKey(shot.image)
    return {
      slug: `${packId}--${key}`,
      name: shot.title,
      desc: shot.desc.length > 72 ? `${shot.desc.slice(0, 70)}…` : shot.desc,
      tag: meta.platformName,
      load: meta.load,
      model: meta.model,
      productKind: 'system',
      isSystemModule: true,
      systemPackId: packId,
      image: shot.image,
      imageFallback: shot.fallback,
      tagline: shot.desc,
      highlightParams: pack.highlights,
      specGroups: [
        {
          name: '模块信息',
          rows: [
            ['所属平台', meta.platformName],
            ['功能模块', shot.title],
            ['能力说明', shot.desc],
          ],
        },
      ],
    }
  })
}

/** 合并到 productCatalog 里某条 product 的字段（整平台一条时用） */
export function systemProductFields(packId) {
  const pack = packs[packId]
  if (!pack) return {}
  return {
    productKind: 'system',
    systemPackId: packId,
    image: pack.galleryCover,
    imageFallback: pack.coverFallback,
    screenshots: pack.screenshots,
    tagline: pack.tagline,
    highlightParams: pack.highlights,
  }
}

export function shotDisplaySrc(shot, useFallback) {
  return useFallback ? shot.fallback : shot.image || shot.fallback
}

const packCategoryMap = {
  'smart-power-cloud': 'software',
  'smart-pv-cloud': 'energy-system',
}

/** 首页等平台展示：用电 / 光伏代表模块（与产品中心小产品同 slug） */
export function featuredPlatformModules(perPack = 3) {
  const out = []
  for (const packId of Object.keys(packCategoryMap)) {
    const pack = packs[packId]
    const meta = platformMeta[packId]
    if (!pack || !meta) continue
    pack.screenshots.slice(0, perPack).forEach((shot) => {
      out.push({
        categoryId: packCategoryMap[packId],
        slug: `${packId}--${shotFileKey(shot.image)}`,
        name: shot.title,
        desc: shot.desc.length > 64 ? `${shot.desc.slice(0, 62)}…` : shot.desc,
        image: shot.image,
        imageFallback: shot.fallback,
        platform: meta.platformName,
      })
    })
  }
  return out
}